/**
 * Admin Portal → Codes → All codes — `/admin/codes/all` (every code, one list, the unified words) and
 * its Batches tab, `/admin/codes/all/batches[/:batchId]` (every code's batch, each family's own words).
 * Codes PR-8; the lead's unified-codes design §2.1.
 *
 * The list's filters come from the address too, so a link can open a family, a batch or one API key's
 * codes (`?family=…`, `?batch_id=…`, `?api_key_id=…`).
 *
 * Web-only (the admin SPA).
 */

import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { ReadOnlyNote } from '../partners/PartnersShared';
import { AdminCodeBatches } from './AdminCodeBatches';
import { CodeCatalogPanel } from './CodeCatalogPanel';
import { CODES_ROUTES, filtersFromSearch } from './codesAreaLogic';
import { CodesHeader, PAGE, SubTabs, useCodesRole } from './CodesArea';

const TABS = [
  { to: CODES_ROUTES.all, label: 'All codes', exact: true },
  { to: CODES_ROUTES.batches, label: 'Batches' },
];

export function CodesAllCodes({ view = 'codes' }: { view?: 'codes' | 'batches' }) {
  const { role, loaded, writable } = useCodesRole();
  const [search] = useSearchParams();
  const initial = filtersFromSearch(search);
  return (
    <div style={PAGE}>
      <CodesHeader title="All codes" subtitle="Search every code Coach Cedar issued — Summer50, one-off, referral, partner and Coach Cedar codes." />
      <SubTabs tabs={TABS} />
      {view === 'batches' ? (
        <AdminCodeBatches embedded />
      ) : (
        <>
          <ReadOnlyNote writable={writable} loaded={loaded} role={role} subject="codes" />
          {/* keyed on the address: a link to another family or key starts a fresh search */}
          <CodeCatalogPanel key={search.toString()} initial={initial} writable={writable} roleLoaded={loaded} />
        </>
      )}
    </div>
  );
}

export default CodesAllCodes;
